import { OembedProviderInterface } from '@models/oembed/oembed.provider.interface';

export class VimeoProvider extends OembedProviderInterface {
  name = 'vimeo';
  urls = [/^vimeo\.com\/(\w+)/];

  getVideo(id: string): string {
    return (
      `<iframe src="https://player.vimeo.com/video/${id}" ` +
      'width="640" height="360" ' +
      'frameborder="0" allow="autoplay; fullscreen" allowfullscreen>' +
      '</iframe>'
    );
  }
}
